import request from '@/utils/request'

// 获取在线用户列表
export function getOnlineUsers(params) {
  return request({
    url: '/admin/online',
    method: 'get',
    params
  })
}

// 强制用户下线
export function forceLogout(data) {
  return request({
    url: '/admin/online/logout',
    method: 'post',
    data
  })
}

// 批量强制用户下线
export function batchForceLogout(data) {
  return request({
    url: '/admin/online/batch-logout',
    method: 'post',
    data
  })
}
